"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayQRButton = void 0;
const menu_button_1 = require("@reach/menu-button");
require("@reach/menu-button/styles.css");
const react_1 = __importDefault(require("react"));
const components_1 = require("./components");
const display_qr_button_constants_1 = require("./display-qr-button.constants");
const display_qr_button_styles_1 = require("./display-qr-button.styles");
require("./display-qr-button.types");
const qr_code_png_1 = __importDefault(require("./icons/qr-code.png"));
const DisplayQRButton = ({ width, buttonLabel, buttonColor, buttonHeight, dropdownTitle, dropdownSubtitle, className, }) => (react_1.default.createElement(menu_button_1.Menu, null,
    react_1.default.createElement(components_1.Button, { buttonColor: buttonColor, width: width, buttonHeight: buttonHeight }, buttonLabel || display_qr_button_constants_1.DEFAULT_BUTTON_LABEL),
    react_1.default.createElement(components_1.Dropdown, { width: width, className: className },
        dropdownTitle && react_1.default.createElement(components_1.DropdownTitle, null, dropdownTitle),
        react_1.default.createElement(components_1.DropdownSubTitle, null, dropdownSubtitle || display_qr_button_constants_1.DEFAULT_DROPDOWN_SUBTITLE),
        react_1.default.createElement(display_qr_button_styles_1.StyledQRBox, null,
            react_1.default.createElement(display_qr_button_styles_1.StyledIMG, { src: qr_code_png_1.default, alt: "qr-icon" })))));
exports.DisplayQRButton = DisplayQRButton;
